import { render, staticRenderFns } from "./2026edukorea.vue?vue&type=template&id=3d18462d&scoped=true"
import script from "./2026edukorea.vue?vue&type=script&lang=js"
export * from "./2026edukorea.vue?vue&type=script&lang=js"
import style0 from "./2026edukorea.vue?vue&type=style&index=0&id=3d18462d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d18462d",
  null
  
)

export default component.exports